import React, {useEffect} from "react"
import PropTypes from "prop-types"
import styled, {ThemeProvider} from "styled-components"
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import isTouchDevice from "is-touch-device"
import classNames from "classnames"
// import "slick-carousel/slick/slick.css"
// import "slick-carousel/slick/slick-theme.css"
import Modal from "components/shared/Modal";
import 'scss/main.scss'
import Seo from "utils/Seo"
import {getParameterByName} from "utils/Helpers"
import GlobalStyles from "utils/GlobalStyles"
import theme from "utils/Theme"
import Header from "components/Header/Header"
import Footer from "components/Footer/Footer"
import SocialGlobal from "components/shared/SocialGlobal"
// import SignupModal from "components/shared/SignupModal"
import {useCookies} from 'react-cookie';

const SiteWrap = styled.div`
  /* padding-top: 100px; */

  &.noPadding {
    padding-top: 0;
  }
`

const Layout = (props) => {
    const [cookies, setCookie] = useCookies(['name']);
    useEffect(() => {
        const handleFirstTab = (e) => {
            if (e.keyCode === 9) { // the "I am a keyboard user" key
                document.body.classList.add('user-is-tabbing');
                window.removeEventListener('keydown', handleFirstTab);
            }
        }

        const attachTrackingToLinks = () => {
            const links = document.querySelectorAll('a, button');

            links && Array.prototype.forEach.call(links, link => {
                const text = link.innerText ? link.innerText : "n/a"
                const href = link.href ? link.href : "n/a"

                // Add event listener to each
                link.addEventListener("click", function (e) {
                    // e.preventDefault();

                    if (window.analytics) {
                        window.analytics.track("Button/Link click", {
                            text: text,
                            link: href
                        })
                    }
                })
            })
        }

        // const detectSignupConfirm = () => {
        //     const path = props.path
        //     const fullname = getParameterByName('fullname')
        //     const email = getParameterByName('email')

        //     if (path === "/thank-you/" && fullname !== null && email !== null) {
        //         window.analytics.track("Sign up confirmation", {
        //             fullname: fullname,
        //             email: email,
        //         })
        //     }
        // }

        attachTrackingToLinks()
        // detectSignupConfirm()
        window.addEventListener('keydown', handleFirstTab);

        return () => {
            window.removeEventListener('keydown', handleFirstTab);
        }
    })

    return (
        <GoogleReCaptchaProvider reCaptchaKey={process.env.RECAPTCHA_SITE_KEY}>
        <ThemeProvider theme={theme}>
            <>
                <Seo seo={props.seo} path={props.path}/>
                <GlobalStyles/>
                <Modal path={props.path}/>
                {/* {props.path === "/"
                    && !cookies.signup_open &&
                    <SignupModal setCookie={setCookie}/>
                } */}
                <SiteWrap className={classNames({
                    siteWrap: true,
                    touch: isTouchDevice(),
                    noPadding: !props.header
                })}>
                    {props.header &&
                        <Header path={props.path}/>
                    }
                    {props.social &&
                        <SocialGlobal/>
                    }
                    <main>{props.children}</main>
                    {props.footer &&
                        <Footer path={props.path}/>
                    }
                </SiteWrap>
            </>
        </ThemeProvider>
        </GoogleReCaptchaProvider>
    )
}

export default Layout

Layout.defaultProps = {
    header: true,
    footer: true,
    social: true
}

Layout.propTypes = {
    children: PropTypes.node.isRequired,
}